import Constant from '@/common/constant/Constant';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import Logger from '@/common/utils/Logger';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import classNames from '@/component/chatThread/chatInput/CustomStyle.module.css';
import defaultMentionStyle from '@/component/chatThread/chatInput/defaultMentionStyle';
import { renderStatusSendMsgError } from '@/component/chatThread/component/ChatPost';
import {
    createTmpUploadedFiles,
    getDelegateUserDetail,
    onSubmitCreateMsg
} from '@/component/chatThread/handler/ChatPostHandler';
import {
    autoScrollPositionFocus,
    disableAutoScroll,
    getFootprintNumber,
    initObserverFootprint,
    isDisabledShowReadList,
    isShowReadNumber,
    onClickPopoverFootprint
} from '@/component/chatThread/handler/FootprintHandler';
import {
    getContentChatPost,
    handleScrollListMessage,
    initObserverLastMsg,
    isDeleteMsg,
    isEditedMsg,
    isShowBlockMsgKnowLedge,
    isShowDeleteTmpMsg,
    openShareLinkTicket,
    updateChatPostBySubsciptionResponse
} from '@/component/chatThread/handler/MessageHandler';
import { updateUserWorkspacePanel } from '@/common/utils/ServiceFactoryUtil';
import {
    initSubscriptionChatPostKnowledge,
    initSubscriptionMentionChat
} from '@/component/chatThread/handler/SubsciptionHandler';
import DeleteMessageDialog from '@/component/chatThread/messageDialog/DeleteMessageDialog';
import LoadingIndicator from '@/component/common/LoadingIndicator';
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import {
    initSubscriptionTicket,
    unsubscribeEventTicket
} from '@/component/common/TicketSubscriptionHandler';
import { unsubscribeAll } from '@/component/chatThread/handler/SubsciptionHandler';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import ErrorModal from '@/component/common/modal/ErrorModal';
import { sortByCreatedAtAndSeqAsc } from '@/service/chatPostService';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Popover,
    Tooltip
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/InfoTwoTone';
import _, { cloneDeep } from 'lodash';
import { createRef, useEffect, useRef, useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import { ListReactionByChatPost } from '../component/ListReactionByChatPost';
import { ReactionChatPost } from '../component/ReactionChatPost';
import { TicketKnowledgeHead } from '../component/TicketKnowledgeHead';
import EditChatPost from '../chatInput/EditChatPost';
import ReactionErrorDialog from '../messageDialog/ReactionErrorDialog';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    setPanelSelector,
} from '@/state/selector/panelSelector';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import {
    getListActiveB2BCustomerSelector,
    getListActiveB2BHelpdeskSelector
} from '@/state/selector/ticketSelector';
import { signOut } from '@/service/authenService';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import FlagMessageCopy from '../tooltip/FlagMessageCopy';
import { PropTypes } from 'prop-types';
import { useSnackbar } from 'notistack';
import { v4 as uuidv4 } from 'uuid';
import { updatePublicAPI } from '@/service/publicService';
import { useDropzone } from 'react-dropzone';
import FileIcon from '@material-ui/icons/InsertDriveFile';
import { AttachFile } from '../AttachFile';
import { ChatBoxToolKnowledge } from './ChatBoxToolKnowledge';
import {
    getChatAttachmentFiles,
    isChatImageAttachment
} from '../handler/ChatAttachmentHandler';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { autoTranslateNewMessages, initChatPostOnDemand } from '@/component/multiLanguage/handlers/ChatPostOnDemandHandler';
import { chatPostOnDemandAtom } from '@/state/atom/translationAtom';
import ChatPostTranslationView from '@/component/multiLanguage/elements/ChatPostTranslationView';
import useKeepChatScrollOnViewChange from '@/component/multiLanguage/hooks/useKeepChatScrollOnViewChange';
import CorporationUtils from '@/common/utils/CorporationUtils';
import { generateKnowledgeOutlineOnTabChat } from '@/component/ticketList/handler/TicketHandler';
import TranslationConstant from '@/common/constant/TranslationConstant';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

ChatKnowledge.propTypes = {
    focusedMsgId: PropTypes.any,
    setFocusedMsgId: PropTypes.any,
    corporationDetail: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    ticketInfo: PropTypes.any
};

export default function ChatKnowledge({
    API,
    ticketInfo,
    setTicketInfo,
    selectThread,
    setIsLoading,
    userDetail,
    setUserDetail,
    chatPostAllList,
    isShowAllChatPost,
    setIsShowAllChatPost,

    knowledgeThread,
    ticketIdSelected,
    history,
    setChatPostUpdate,
    panelId,
    chatPostUpdate,
    projectInuseDetail,
    setProjectInuseDetail,
    corporationDetail,

    subsciptionChatPostUpdateResponse,
    setSubsciptionChatPostUpdateResponse,
    projectIdListForSubscriptionMention,
    userListCanMention,
    setUserChatList,
    tabId,
    triggerReloadKnowledgeChat,
    setTriggerReloadKnowledgeChat,
    chatThreadCorporationDetail,
    focusedMsgId,
    setFocusedMsgId,
    ...props
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const setPanelList = useSetRecoilState(multiPanelAtom);

    const [chatPostOnDemand, setChatPostOnDemand] = useRecoilState(chatPostOnDemandAtom);
    // Timer for debouncing (batching) on-demand auto-translation of new messages.
    const autoTranslateTimerRef = useRef(null);

    const [chatPostByChatThreadIdList, setChatPostByChatThreadIdList] = useState([]);
    const [chatThreadId, setChatThreadId] = useState('');
    const [isModalUploadFileError, setIsModalUploadFileError] = useState(false);

    const corporationId = localStorageUtil.getAffiliationOrganization();
    const selectedProjectId = localStorageUtil.getSelectedProjectId();

    // footprint
    const [msgRefList, setMsgRefList] = useState([]);
    const [userFootprintList, setUserFootprintList] = useState([]);

    const isArchive = ticketInfo.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;

    const [msgEditSelected, setMsgEditSelected] = useState();
    const [isShowModalEditMsg, setIsShowModalEditMsg] = useState(false);
    const [isCreateNewMsg, setIsCreateNewMsg] = useState(false);
    const [isShowReconnectDialog, setIsShowReconnectDialog] = useState(false);
    const chatThreadAll = {};

    // footprint opover
    const [footPrintPopover, setFootPrintPopover] = useState(null);
    const openPopover = Boolean(footPrintPopover);
    const id = openPopover ? 'simple-popover' : undefined;

    // dialog history msg
    const [isOpenHistoryDialog, setIsOpenHistoryDialog] = useState(false);
    const [historyList, setHistoryList] = useState([]);
    const [isLoadingHistoryList, setIsLoadingHistoryList] = useState(false);
    const [msgContentList, setMsgContentList] = useState({});
    const [editedMsgList, setEditedMsgList] = useState({});
    const [statusDeleteMsgList, setStatusDeleteMsgList] = useState({});
    const [footprintDetailList, setFootprintDetailList] = useState({});
    const [isEnableChat, setIsEnableChat] = useState(true);
    const [isDisplayJump, setIsDisplayJump] = useState(false);

    const [isDisabledBtnSend, setIsDisableBtnSend] = useState(true);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isOpenModalTicketDeleted, setIsOpenModalTicketDeleted] = useState(false);
    const [disableButtonCallBack, setDisableButtonCallBack] = useState(false);
    const [newMessage, setNewMessage] = useState('');
    let [listRenderMention, setListRenderMention] = useState([]);

    const [reactionPopover, setReactionPopover] = useState(null);
    const [reactionPopoverId, setReactionPopoverId] = useState(null);
    const openReactionPopover = Boolean(reactionPopover);
    const reactionId = reactionPopover ? 'reaction-popover' : undefined;

    const [openModalDeleteMsg, setOpenModalDeleteMsg] = useState({ isOpen: false, msg: null });
    const [isShowConfirmMaxFileSize, setIsShowConfirmMaxFileSize] = useState(false);

    const [reactionErrorMsg, setReactionErrorMsg] = useState('');
    const [isOpenReactionErrorDialog, setIsOpenReactionErrorDialog] = useState(false);
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup, setIsOpenNotFoundTicketPopup] = useState(false);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const setLastUserAction = useSetRecoilState(helpdeskTicketLastUserActionAtom);

    const listB2BCustomerRecoilState = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpdeskRecoilState = useRecoilValue(getListActiveB2BHelpdeskSelector);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const [chatPostShowFlagMsgCopyMsgId, setChatPostShowFlagMsgCopyMsgId] = useState({});
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: trI18n('MSG-CM-DELETED-CONTENT'),
        confirmTxt: trI18n('CM-BUTTON-OK')
    });
    const [triggerFocusMsg, setTriggerFocusMsg] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [uploadFiles, setUploadFiles] = useState([]);
    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [loadingInput, setLoadingInput] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const currentProjectB2BCustomerIdList = () => {
        let b2bCustomerIdList = [];
        if (!Utils.isEmptyArray(listB2BCustomerRecoilState)) {
            listB2BCustomerRecoilState.forEach(project => {
                b2bCustomerIdList.push(project.id);
            });
        }
        return b2bCustomerIdList;
    };

    const currentProjectB2BHelpdeskIdList = () => {
        let b2bHelpdeskIdList = [];
        if (!Utils.isEmptyArray(listB2BHelpdeskRecoilState)) {
            listB2BHelpdeskRecoilState.forEach(project => {
                b2bHelpdeskIdList.push(project.id);
            });
        }
        return b2bHelpdeskIdList;
    };

    let args = {
        API: API,
        msgContentList: msgContentList,
        setMsgContentList: setMsgContentList,
        statusDeleteMsgList: statusDeleteMsgList,
        setStatusDeleteMsgList: setStatusDeleteMsgList,
        editedMsgList: editedMsgList,
        setEditedMsgList: setEditedMsgList,
        isOpenModalTicketDeleted,
        setIsOpenModalTicketDeleted,
        footprintDetailList: footprintDetailList,
        setFootprintDetailList: setFootprintDetailList,
        chatPostAllList: chatPostAllList,
        isShowAllChatPost: isShowAllChatPost,
        chatThreadSelected: selectThread,
        setChatPostAllList: props.setChatPostAllList,
        setIsShowReconnectDialog: setIsShowReconnectDialog,
        isShowReconnectDialog: isShowReconnectDialog,
        setChatPostUpdate: setChatPostUpdate,
        ticketDetailSelected: ticketInfo,
        setIsDisableUserListDelegateMsg: () => {},
        setSubsciptionChatPostUpdateResponse: setSubsciptionChatPostUpdateResponse,
        panelId: panelId,
        isDisplayJump,
        setIsDisplayJump,
        setIsLoading,
        // chat thread
        chatThreadAll,
        projectInuseDetail: projectInuseDetail,
        userDetail,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        isChartThreadSubscription: true,
        reactionPopoverId,
        setReactionPopover,
        reactionPopover,
        setReactionPopoverId,
        openReactionPopover,
        reactionId,
        selectThread,
        isEnableChat,
        openModalDeleteMsg,
        setOpenModalDeleteMsg,
        setUserChatList,
        userListCanMention,
        setIsShowModalEditMsg,
        msgEditSelected,
        ...props,
        userChatList: props.userChatList,
        reactionErrorMsg,
        setReactionErrorMsg,
        isOpenReactionErrorDialog,
        setIsOpenReactionErrorDialog,
        currentProjectB2BCustomerIdList: currentProjectB2BCustomerIdList(),
        currentProjectB2BHelpdeskIdList: currentProjectB2BHelpdeskIdList()
    };

    useEffect(() => {
        return () => {
            // cleanup
            setChatPostByChatThreadIdList([]);
            setChatThreadId('');
            setIsModalUploadFileError(false);
            setMsgRefList([]);
            setUserFootprintList([]);
            setMsgEditSelected();
            setIsShowModalEditMsg(false);
            setIsCreateNewMsg(false);
            setIsShowReconnectDialog(false);
            setFootPrintPopover(null);
            setIsOpenHistoryDialog(false);
            setHistoryList([]);
            setIsLoadingHistoryList(false);
            setMsgContentList({});
            setEditedMsgList({});
            setStatusDeleteMsgList({});
            setFootprintDetailList({});
            setIsEnableChat(true);
            setIsDisplayJump(false);
            setIsDisableBtnSend(true);
            setIsOpenModalReloadPage(false);
            setIsOpenModalTicketDeleted(false);
            setDisableButtonCallBack(false);
            setNewMessage('');
            setListRenderMention([]);
            setReactionPopover(null);
            setReactionPopoverId(null);
            setOpenModalDeleteMsg(null);
            setIsShowConfirmMaxFileSize(false);
            setReactionErrorMsg('');
            setIsOpenReactionErrorDialog(false);
            setIsOpenPopupKnowledgeOff(false);
            setIsOpenAccessDeniedPopup(false);
            setIsOpenNotFoundTicketPopup(false);
            args = {};
        };
    }, []);

    useEffect(() => {
        if (
            ticketInfo.hasOneSideBlockedOrg ||
            ticketInfo.hasOneSideDeletedOrg ||
            !Utils.isEmptyString(ticketInfo.deletedAt) ||
            ticketInfo.public === Constant.TICKET_PUBLIC.DRAFT
        ) {
            setIsEnableChat(false);
        } else {
            // restore ticket
            setIsEnableChat(true);
        }
    }, [ticketInfo]);

    /**
     * Init subscription chat post
     */
    useEffect(() => {
        // init subscription handler
        chatThreadAll.knowledgeThread = knowledgeThread;
        initSubscriptionChatPostKnowledge(args);

        return () => unsubscribeAll(panelId);
    }, [knowledgeThread, chatPostAllList, selectThread]);

    useEffect(() => {
        initSubscriptionTicket(args);
        return () => unsubscribeEventTicket(Constant.SUBSCRIPTION_TYPE.UPDATE, panelId, args);
    }, [ticketInfo, panelId]);

    /**
     * Check delegate thread
     */
    useEffect(() => {
        setChatThreadId(selectThread?.id);
    }, [selectThread]);

    useEffect(() => {
        Logger.info(
            'useEffect onSubscriptionEventUpdateChatPost: ',
            subsciptionChatPostUpdateResponse
        );

        if (Utils.isEmptyObject(subsciptionChatPostUpdateResponse)) {
            return;
        }

        updateChatPostBySubsciptionResponse(
            {
                chatPostAllList,
                API,
                msgContentList,
                setMsgContentList,
                editedMsgList,
                setEditedMsgList,
                statusDeleteMsgList,
                setStatusDeleteMsgList,
                setChatPostUpdate,
                footprintDetailList,
                setFootprintDetailList,
                userChatList: props.userChatList,
                setUserChatList: props.setUserChatList
            },
            subsciptionChatPostUpdateResponse
        );
    }, [subsciptionChatPostUpdateResponse]);

    /**
     * Get chat post list by chatThreadId
     */
    useEffect(() => {
        let chatPostList = Utils.isEmptyString(chatThreadId) ? [] : chatPostAllList;
        if (!isShowAllChatPost) {
            chatPostList = _.filter(chatPostAllList, post => {
                return post.chatThreadId === chatThreadId;
            });
        }
        setChatPostByChatThreadIdList(chatPostList);

    }, [chatThreadId, isShowAllChatPost, chatPostAllList, props.isDataChanged]);

    /**
     * Init / refresh on-demand translation state for the current chat thread (CHT-005),
     * driven by the SAME list the UI renders (chatPostByChatThreadIdList) so the atom
     * stays in sync with newly arrived posts. Kept in its own effect (mirrors Chat.js)
     * so it only runs on translation-relevant inputs.
     */
    useEffect(() => {
        if (!CorporationUtils.isEnableSettingMultiLanguage(corporationDetail)) return;

        initChatPostOnDemand({
            setChatPostOnDemand,
            chatThreadId,
            threadType: selectThread?.threadType,
            postList: chatPostByChatThreadIdList,
            ticketOutline: generateKnowledgeOutlineOnTabChat(ticketInfo),
            ticketId: ticketInfo?.id,
            threadChatList: [{...selectThread}]
        });
    }, [
        corporationDetail,
        chatThreadId,
        chatPostByChatThreadIdList,
        selectThread?.threadType,
        ticketInfo
    ]);

    /**
     * Auto-translate messages that arrive while a thread is already ON (CHT-005 §4.4).
     * Driven by the atom: when init merges a new untranslated message into an ON
     * thread, this triggers its translation. The handler skips threads that are
     * translating and messages already in flight, so it does not loop.
     *
     * Debounced (batching): instead of firing a request as soon as one message
     * arrives, we wait AUTO_TRANSLATE_DEBOUNCE_MS of "silence". Each new message
     * resets the timer, so a burst of messages is collected and sent as ONE request
     * (autoTranslateNewMessages / getListMsgTranslateByThread already gather ALL
     * pending messages of the thread into a single payload).
     */
    useEffect(() => {
        if (!CorporationUtils.isEnableSettingMultiLanguage(corporationDetail)) return;

        // Reset the pending timer whenever the atom changes (a new message arrived
        // or a previous request finished) so a burst is batched together.
        if (autoTranslateTimerRef.current) {
            clearTimeout(autoTranslateTimerRef.current);
        }
        autoTranslateTimerRef.current = setTimeout(() => {
            autoTranslateNewMessages({
                chatPostOnDemand,
                setChatPostOnDemand,
                ticketInfo,
                isOverlap: Boolean(isShowAllChatPost),
                setIsOpenModalReloadPage
            });
        }, TranslationConstant.AUTO_TRANSLATE_DEBOUNCE_MS);

        return () => {
            if (autoTranslateTimerRef.current) {
                clearTimeout(autoTranslateTimerRef.current);
            }
        };
    }, [corporationDetail, chatPostOnDemand, ticketInfo]);

    const validateFilesUpload = (filesUpload = []) => {
        if (filesUpload.length + uploadFiles.length > Constant.LIMIT_FILES_UPLOAD) {
            enqueueSnackbar(buildSnackbarMessage('INVALID_TOO_MANY_FILES'), {
                variant: 'error',
                autoHideDuration: 2000
            });
            return false;
        }
        if (filesUpload.some(item => item.size > 50 * 1024 * 1024)) {
            enqueueSnackbar(buildSnackbarMessage('INVALID_TOO_LARGE_FILE'), {
                variant: 'error',
                autoHideDuration: 2000
            });
            return false;
        }
        return true;
    };

    const handlePostImageFileOnChange = event => {
        const filesUpload = Array.from(event.target.files);
        if (!validateFilesUpload(filesUpload) || loadingInput) {
            return;
        }
        event.target.value = '';
        uploadTmpFile(filesUpload);
    };

    const handlePaste = event => {
        const clipboardItems = Array.from(event.clipboardData.items);
        const imageFiles = clipboardItems
            .filter(item => item.type.startsWith('image'))
            .map(item => item.getAsFile());
        if (!validateFilesUpload(imageFiles) || loadingInput) {
            return;
        }
        uploadTmpFile(imageFiles);
    };

    const onDrop = newFiles => {
        if (!validateFilesUpload(newFiles) || loadingInput) {
            return;
        }
        uploadTmpFile(newFiles);
    };

    const uploadTmpFile = newFiles => {
        const files = newFiles.map(file => ({
            id: `tmp_attach_${uuidv4()}`,
            localUrl: URL.createObjectURL(file),
            fileData: file
        }));
        setUploadFiles(prev => [...prev, ...files]);
        createTmpUploadedFiles({
            corporationId: corporationDetail.id,
            projectInuseId: projectInuseDetail.id,
            chatThreadId,
            files,
            setUploadFiles,
            setIsUploading
        });
    };

    const { getRootProps, getInputProps, inputRef } = useDropzone({
        onDrop
    });

    const deleteFile = file => {
        if (loadingInput) {
            return;
        }
        if (inputRef.current) {
            inputRef.current.value = '';
        }
        setUploadFiles(uploadFiles.filter(i => i !== file));
        file.localUrl && URL.revokeObjectURL(file.localUrl);
        updatePublicAPI(null, {
            updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.DELETE_S3_FILE_BY_PATH,
            s3Path: file.s3Path
        });
    };

    useEffect(() => {
        let chatPost = '';

        if (!Utils.isEmptyString(newMessage)) {
            chatPost = newMessage?.trim();
        }

        setIsDisableBtnSend((!chatPost?.length && !uploadFiles.length) || isUploading);
    }, [newMessage, uploadFiles, isUploading]);

    const handleEventOnSubmitMessage = () => {
        let contentPost = newMessage || '';

        if (
            (Utils.isEmptyString(contentPost) || contentPost.trim() === '') &&
            !uploadFiles.length
        ) {
            setNewMessage('');
            setIsDisableBtnSend(true);
            return;
        }

        setLoadingInput(true);
        setIsDisableBtnSend(true);
        let messageParser = [...newMessage.matchAll(/@\[(.*?)]\((.*?)\)/g)];
        const GET_MENTION_ID_REGEX = /(user_[a-z0-9\-]+|ALL)(?=\))/g;
        let mentionsList = newMessage.match(GET_MENTION_ID_REGEX);

        let messageForSave = newMessage;
        let messageForDisplay = newMessage;
        for (const part of messageParser) {
            messageForSave = messageForSave.replace(`${part[0]}`, `@[${part[2]}]`);
            messageForDisplay = 'messageForDisplay';
        }

        let dataSubmit = {
            API: API,
            corporationId: corporationId,
            ticketInfo: ticketInfo,
            chatThreadId: chatThreadId,
            userDetail: userDetail,
            userDelegateCreateTicketDetail: props.userDelegateCreateTicketDetail,
            isDelegateThread: false,
            isPostCreatedAtCurrentTime: true,
            postCreatedAtDateTime: '',
            setIsCreateNewMsg: setIsCreateNewMsg,
            setChatPostAllList: props.setChatPostAllList,
            setMessageError: () => {},
            setChatPostInsertFail: props.setChatPostInsertFail,
            setChatPostUpdate: setChatPostUpdate,
            txtChatPostRef: txtChatPostRef,
            selectedProjectId: selectedProjectId,
            contentPost: messageForSave.trim(),
            messageForDisplay: messageForDisplay,
            mentionsList: mentionsList,
            selectThread: selectThread,
            corporationDetail,
            projectInuseDetail,
            uploadFiles,
            setUploadedFiles
        };
        onSubmitCreateMsg(dataSubmit);
        setNewMessage('');
        setIsDisableBtnSend(true);
        setLoadingInput(false);
        setUploadFiles([]);
    };

    /**
     * Handle enter keypress
     */
    const handleOnKeyPress = async e => {
        let updatedString = newMessage
            .split(' ')
            .filter(Boolean)
            .join(' ');
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (
                (Utils.isEmptyString(updatedString) || updatedString.trim() === '') &&
                Utils.isEmptyArray(uploadFiles)
            ) {
                return;
            }
            handleEventOnSubmitMessage();
        }
    };

    const displayTransform = (id, display) => {
        let lastIndex = display.lastIndexOf(' ');
        let textDisplay = display.substr(0, lastIndex);
        return `@${textDisplay}`;
    };

    const handleSuggestion = e => {
        let lastIndex = e.display.lastIndexOf(' ');
        let textDisplay = e.display.substr(0, lastIndex);
        return (
            <div className="suggestion-wrapper">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ flex: ' 0 0 20px' }}>
                        <img
                            src={e.avatar}
                            alt=""
                            width={'20px'}
                            style={{ borderRadius: '50%', height: '20px' }}
                        />
                    </div>
                    <div>
                        <OverFlowTooltip value={textDisplay} className="suggestion-name" />
                        <OverFlowTooltip value={e.mail} className="suggestion-mail" />
                    </div>
                </div>
            </div>
        );
    };

    const onAddMention = (id, display, startPos, endPos) => {};

    const handleAddNewMessage = e => {
        let contentPost = e.target.value;
        setNewMessage(contentPost);
    };

    useEffect(() => {
        let idDivContentList = `divChatContentList-${panelId}-${chatThreadId}`;
        const element = document.getElementById(idDivContentList);
        if (element) {
            const isAtBottom =
                element.scrollHeight - element.scrollTop - element.clientHeight <= 100;
            setIsDisplayJump(!isAtBottom);
        }
    }, [chatPostUpdate]);

    useEffect(() => {
        let listRenderMentionClone = [];

        if (!Utils.isEmptyArray(userListCanMention)) {
            let userChatListClone = cloneDeep(props.userChatList);

            userListCanMention?.forEach(user => {
                let renderTemplate = {};
                renderTemplate[`id`] = user.id;
                renderTemplate[`display`] =
                    user.id !== Constant.CHAT_MENTION_ALL.id
                        ? `${Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, user)} ${user.mail}`
                        : `${Constant.CHAT_MENTION_ALL.name} all`;
                renderTemplate[`mail`] = user.mail;
                renderTemplate[`avatar`] = user.avatar;

                listRenderMentionClone.push(renderTemplate);

                // update user to userChatList
                if (Utils.findIndexInArrayById(user.id, userChatListClone) === -1) {
                    userChatListClone.push(user);
                }
            });

            setListRenderMention(listRenderMentionClone);
            setUserChatList(userChatListClone);
        }
    }, [userListCanMention]);

    /**
     * Init state:
     * msgContentNewList: content list of msg
     * editedMsgNewList: status edited list of msg
     * statusDeleteMsgNewList: status delete list of msg
     * footprintDetailNewList: footprint list of msg
     */
    useEffect(() => {
        let statusDeleteMsgNewList = { ...statusDeleteMsgList };
        let msgContentNewList = { ...msgContentList };
        let editedMsgNewList = { ...editedMsgList };
        let footprintDetailNewList = { ...footprintDetailList };
        let msgRefNewList = chatPostAllList.reduce((refsObj, msg) => {
            refsObj[msg.id] = createRef();
            msgContentNewList[msg.id] = msg.content;
            editedMsgNewList[msg.id] = Utils.isEmptyArray(msg.history) ? false : true;
            statusDeleteMsgNewList[msg.id] = msg.status;
            footprintDetailNewList[msg.id] = Utils.isEmptyArray(msg.footprintListDetail)
                ? 0
                : msg.footprintListDetail.length;
            return refsObj;
        }, {});
        setMsgRefList(msgRefNewList);
        setStatusDeleteMsgList(statusDeleteMsgNewList);
        setMsgContentList(msgContentNewList);
        setEditedMsgList(editedMsgNewList);
        setFootprintDetailList(footprintDetailNewList);
    }, [chatPostAllList]);

    /**
     * Init observer: footprint, auto scroll last msg, auto scroll to position focus
     */
    useEffect(() => {
        // init observer footprint
        const observerFootprint = initObserverFootprint(
            API,
            msgRefList,
            userDetail,
            chatPostAllList
        );

        let containerChatId = `divChatContentList-${panelId}-${chatThreadId}`;
        const scrollTimeout = setTimeout(() => {
            autoScrollPositionFocus(
                chatPostByChatThreadIdList,
                msgRefList,
                userDetail,
                chatPostAllList,
                containerChatId,
                setTriggerFocusMsg
            );
        });

        // init observer last msg
        const observerLastMsg = initObserverLastMsg(
            panelId,
            chatThreadId,
            isCreateNewMsg,
            setIsCreateNewMsg
        );

        // clenaup the observer if component unmount
        return () => {
            observerFootprint.disconnect();
            observerLastMsg.disconnect();
            clearTimeout(scrollTimeout);
        };
    }, [msgRefList, chatPostAllList, chatPostByChatThreadIdList, isCreateNewMsg]);

    /**
     * Init subscription chat post mention
     */
    useEffect(() => {
        initSubscriptionMentionChat(args, projectIdListForSubscriptionMention);
    }, [projectIdListForSubscriptionMention]);

    const onClickUrlViewTicket = async url => {
        setIsLoading(true);
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            userDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: userDetail,
                setUserDetail: setUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    };
    window.onClickUrlViewTicket = onClickUrlViewTicket;

    /**
     * Render block msg
     */
    const renderChatListByUser = (postList, isAlignLeft = true) => {
        if (typeof postList === 'undefined' || postList.length === 0) {
            return null;
        }
        let contentChatList = [];

        const isDisplayBtnEdit = item => {
            return (
                item.creatorId === userDetail.id &&
                item.chatThreadId === selectThread.id &&
                !isArchive &&
                Utils.isEmptyString(ticketInfo?.deletedAt)
            );
        };

        const isDisplayBtnDelete = item => {
            return (
                item.creatorId === userDetail.id &&
                item.chatThreadId === selectThread.id &&
                !(ticketInfo.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED) &&
                Utils.isEmptyString(ticketInfo?.deletedAt)
            );
        };
        postList.forEach(item => {
            if (Utils.isEmptyObject(msgRefList[item.id])) {
                msgRefList[item.id] = createRef();
            }
            if (item.postType !== Constant.POST_TYPE.MSG) {
                item.type = Constant.S3_FILE_TYPE.CHAT_POST_FILE;
                item.currentChatThreadId = selectThread.id;
                item.sharedRange = selectThread.sharedRange;
                item.chatThreadType = selectThread.threadType;
                item.ticketId = ticketIdSelected;
            }

            const contentIncludeHtml = getContentChatPost(item, props.userChatList, isAlignLeft);

            const attachmentFiles = getChatAttachmentFiles(item?.attachFiles, uploadedFiles[item.id]);
            const images = attachmentFiles.filter(file => isChatImageAttachment(file));
            const files = attachmentFiles.filter(file => !isChatImageAttachment(file));
            const chatBoxToolProps = {
                chatPostAllList,
                ticketInfo,
                item,
                setChatPostShowFlagMsgCopyMsgId,
                genMessageCopyShortLink,
                isDisplayBtnEdit,
                setOpenModalDeleteMsg,
                selectThread,
                isDisplayBtnDelete,
                setReactionPopoverId,
                setReactionPopover,
                reactionId,
                isEnableChat,
                editedMsgList,
                setIsOpenHistoryDialog,
                setIsLoadingHistoryList,
                setHistoryList,
                setMsgEditSelected,
                userChatList: props.userChatList,
                setIsShowModalEditMsg,
                msgRefList,
                setChatPostUpdate,
                chatPostShowFlagMsgCopyMsgId
            };

            contentChatList.push(
                <div className="chatBox-text" id={item.id} ref={msgRefList[item.id]}>
                    {!isDeleteMsg(item, chatPostAllList) && !!images?.length && (
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 5,
                                justifyContent: !isAlignLeft ? 'flex-end' : 'flex-start',
                                marginBottom: 10
                            }}
                        >
                            {images.map(itemFile => (
                                <FlagMessageCopy
                                    key={itemFile.id}
                                    title={trI18n('MSG-COPY-SHARELINK')}
                                    placement="top-end"
                                    open={!!chatPostShowFlagMsgCopyMsgId[itemFile?.id]}
                                >
                                    <div
                                        className={`attach-img-chatpost ${focusedMsgId === item.id &&
                                            'focused-msg'}`}
                                        style={{ borderRadius: 10, position: 'relative' }}
                                    >
                                        <AttachFile
                                            key={itemFile.id}
                                            chatPost={item}
                                            detailTicket={ticketInfo}
                                            file={itemFile}
                                            isAlignLeft={isAlignLeft}
                                            isImageLayout={true}
                                            setIsShowPopupLogout={setIsShowPopupLogout}
                                        />
                                        {!Utils.isEmptyString(item.id) && (
                                            <ChatBoxToolKnowledge
                                                {...chatBoxToolProps}
                                                itemFile={itemFile}
                                            />
                                        )}
                                    </div>
                                </FlagMessageCopy>
                            ))}
                        </div>
                    )}
                    {!isDeleteMsg(item, chatPostAllList) && !!files?.length && (
                        <div className="chat-message-attachments">
                            {files.map((itemFile, index) => (
                                <div
                                    className="chatBoxContent"
                                    data-cy="chat-message-content"
                                    key={itemFile.id || itemFile.key || itemFile?.fileData?.name || index}
                                >
                                    <span className="chatBox-label">
                                        <FlagMessageCopy
                                            title={trI18n('MSG-COPY-SHARELINK')}
                                            placement="top-end"
                                            open={!!chatPostShowFlagMsgCopyMsgId[itemFile?.id]}
                                        >
                                            <span
                                                className={`chatBox-txt chat-message-attachment-row attach-img-chatpost color-stack-internal ${focusedMsgId ===
                                                    item.id && 'focused-msg'}`}
                                            >
                                                <AttachFile
                                                    chatPost={item}
                                                    detailTicket={ticketInfo}
                                                    file={itemFile}
                                                    isAlignLeft={isAlignLeft}
                                                    setIsShowPopupLogout={setIsShowPopupLogout}
                                                />
                                                {!Utils.isEmptyString(item.id) && (
                                                    <ChatBoxToolKnowledge
                                                        {...chatBoxToolProps}
                                                        itemFile={itemFile}
                                                    />
                                                )}
                                            </span>
                                        </FlagMessageCopy>
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="chatBoxContent" data-cy="chat-message-content">
                        {item.insertFail && (
                            <WarningIcon color="error" size="small" style={{ margin: 'auto' }} />
                        )}
                        {!isDeleteMsg(item, chatPostAllList) && (
                            <span className="chatBox-label">
                                {!Utils.isEmptyString(item.content) && (
                                    <FlagMessageCopy
                                        title={trI18n('MSG-COPY-SHARELINK')}
                                        placement="top-end"
                                        open={!!chatPostShowFlagMsgCopyMsgId[item?.id]}
                                    >
                                        <span
                                            className={`${focusedMsgId === item.id &&
                                                'focused-msg'} chatBox-txt color-stack-internal${
                                                isAlignLeft ? '-sender' : ''
                                            }`}
                                            onMouseEnter={() =>
                                                getDelegateUserDetail(
                                                    API,
                                                    item,
                                                    () => {}
                                                )
                                            }
                                        >
                                            {(Utils.isEmptyString(item.id) && !item.insertFail) ||
                                            item.isLoading ? (
                                                <main
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <CircularProgress
                                                        size={14}
                                                        color={'inherit'}
                                                        style={{ marginRight: '5px' }}
                                                    />
                                                    <ChatPostTranslationView
                                                        threadId={item.chatThreadId || chatThreadId}
                                                        selectThread={selectThread}
                                                        postId={item.id}
                                                        mention={item?.mention}
                                                        userChatList={props.userChatList}
                                                        isAlignLeft={isAlignLeft}
                                                    >
                                                        <p dangerouslySetInnerHTML={{__html: contentIncludeHtml}} />
                                                    </ChatPostTranslationView>
                                                </main>
                                            ) : (
                                                <ChatPostTranslationView
                                                    threadId={item.chatThreadId || chatThreadId}
                                                    selectThread={selectThread}
                                                    postId={item.id}
                                                    mention={item?.mention}
                                                    userChatList={props.userChatList}
                                                    isAlignLeft={isAlignLeft}
                                                >
                                                    <div className="displayMessage" dangerouslySetInnerHTML={{__html: contentIncludeHtml}} />
                                                </ChatPostTranslationView>
                                            )}
                                            {!Utils.isEmptyString(item.id) && (
                                                <ChatBoxToolKnowledge {...chatBoxToolProps} />
                                            )}
                                        </span>
                                    </FlagMessageCopy>
                                )}
                                {!isDeleteMsg(item, chatPostAllList) && (
                                    <div className="chatBox-view">
                                        {/* show status edited */}
                                        {/* start footprint */}
                                        {getFootprintNumber(
                                            item.footprintListDetail,
                                            footprintDetailList[item.id]
                                        ) > 0 && (
                                            <div className="numberView">
                                                <Button
                                                    className={`numberView-btn ${
                                                        !isShowReadNumber(userDetail, ticketInfo)
                                                            ? 'disable'
                                                            : ''
                                                    }`}
                                                    aria-describedby={id}
                                                    variant="contained"
                                                    onClick={e =>
                                                        onClickPopoverFootprint(
                                                            e,
                                                            item,
                                                            setFootPrintPopover,
                                                            chatPostAllList,
                                                            setUserFootprintList
                                                        )
                                                    }
                                                    disabled={isDisabledShowReadList(
                                                        userDetail,
                                                        ticketInfo
                                                    )}
                                                >
                                                    <img
                                                        src="/assets/image/footprints.svg"
                                                        alt=""
                                                    />
                                                </Button>
                                                <Popover
                                                    className="numberView-sub"
                                                    id={id}
                                                    open={openPopover}
                                                    anchorEl={footPrintPopover}
                                                    onClose={e => setFootPrintPopover(null)}
                                                    anchorOrigin={{
                                                        vertical: 'bottom'
                                                    }}
                                                >
                                                    <div
                                                        className="listView"
                                                        id={`footprint_id_${item.id}`}
                                                    >
                                                        <h3 className="title">
                                                            {tr('あしあとを付けた人')}
                                                        </h3>
                                                        <ul>{userFootprintList}</ul>
                                                    </div>
                                                </Popover>
                                            </div>
                                        )}
                                        {getFootprintNumber(
                                            item.footprintListDetail,
                                            footprintDetailList[item.id]
                                        ) > 0 &&
                                            isShowReadNumber(userDetail, ticketInfo) && (
                                                <span className="number">
                                                    {getFootprintNumber(
                                                        item.footprintListDetail,
                                                        footprintDetailList[item.id]
                                                    )}
                                                </span>
                                            )}
                                    </div>
                                )}
                            </span>
                        )}

                        {isShowDeleteTmpMsg(item, statusDeleteMsgList, chatPostAllList) &&
                            isAlignLeft && (
                                <span className="chatBox-label">
                                    <span
                                        className={`chatBox-txt color-stack-internal${
                                            isAlignLeft ? '-sender' : ''
                                        }`}
                                    >
                                        <span className="chatBox-label chatBox-label--delete">
                                            {trI18n('MSG_DELETED')}
                                        </span>
                                    </span>
                                </span>
                            )}
                        {!isDeleteMsg(item, chatPostAllList) && (
                            <ListReactionByChatPost
                                chatPost={item}
                                isAlignLeft={isAlignLeft}
                                {...args}
                            />
                        )}
                    </div>
                    {renderStatusSendMsgError(item)}
                    {/* start modal edit msg */}
                    {!Utils.isEmptyObject(isShowModalEditMsg[item.id]) &&
                        isShowModalEditMsg[item.id] &&
                        !uploadedFiles[item.id]?.find(i => !i?.shortKey) && (
                            <EditChatPost
                                {...args}
                                ticketInfo={ticketInfo}
                                itemChatPost={item}
                                attachFiles={item?.attachFiles || uploadedFiles[item.id] || []}
                            />
                        )}
                    {/* end modal edit msg */}
                    <ReactionChatPost chatPost={item} {...args} />
                </div>
            );
        });
        let post = postList[0];
        let avatar = post.userDetailPostMsg.avatar;
        // check show message

        // if (
        //     Utils.isEmptyArray(post.attachFiles) &&
        //     Utils.isEmptyString(post.content) &&
        //     post.postType !== Constant.POST_TYPE.MSG_FILES
        // ) {
        //     return <></>;
        // }
        let chatBoxDiv = isShowBlockMsgKnowLedge(postList, statusDeleteMsgList, userDetail?.id) && (
            <div
                className={isAlignLeft ? 'chatBox' : 'chatBox chatBox--change'}
                key={post.id}
                data-cy="chat-message-box"
            >
                <div className="chatBox-info">
                    {isAlignLeft && (
                        <div className="chatBox-thumb">
                            <img src={avatar} alt="" />
                        </div>
                    )}
                    <div className="chatBox-content">
                        <div className="chatBox-dateTime">
                            <OverFlowTooltipWithTabsMui
                                value={Utils.getFullNameOfUserWithCorporationStatus(
                                    Constant.LANGUAGE_TYPE.JP,
                                    post.userDetailPostMsg,
                                    '',
                                    ticketInfo
                                )}
                                className="name"
                            />
                            <span className="time">
                                {Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(post.createdAt)}
                            </span>
                            {isEditedMsg(editedMsgList, post) && (
                                <span className="edited">{tr('Edited')}</span>
                            )}
                        </div>
                        {contentChatList}
                    </div>
                </div>
            </div>
        );
        return chatBoxDiv;
    };

    const genMessageCopyShortLink = messageChat => {
        return `${window.location.origin}/${Utils.getUrlShortShareLinkTicket({
            chatPostId: messageChat?.id,
            shortKey: ticketInfo?.dataShareLink?.shortKey,
            subDomain: ticketInfo?.dataShareLink?.generateLinkCorporationDomain,
            type: ticketInfo?.dataShareLink?.type
        })}`;
    };

    /**
     * Render chat post list
     */
    const renderChatList = () => {
        // sort array
        let postDetailListSorted = sortByCreatedAtAndSeqAsc(
            JSON.parse(JSON.stringify(chatPostByChatThreadIdList))
        );
        // group msg by date, createdAt
        let blockMsgHash = Object.create(null);
        let blockMsgList = [];

        let prevUserPostMsg = '';
        postDetailListSorted.forEach(post => {
            if (post.postType === Constant.POST_TYPE.TICKET_REMOVED) {
                return;
            }
            let createdAt = Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(post.createdAt);
            let key = `${post.userDetailPostMsg.id}/${createdAt}`;

            if (!blockMsgHash[key] || prevUserPostMsg !== post.creatorId) {
                blockMsgHash[key] = [];
                let blockMsg = {
                    isAlignLeft: userDetail.id === post.userDetailPostMsg.id ? false : true,
                    msgList: blockMsgHash[key]
                };
                blockMsgList.push(blockMsg);
            }
            prevUserPostMsg = post.creatorId;
            blockMsgHash[key].push(post);
        });

        // build msg
        let mgsList = [];
        blockMsgList.forEach(blockMsg => {
            mgsList.push(renderChatListByUser(blockMsg.msgList, blockMsg.isAlignLeft));
        });
        return mgsList;
    };

    const txtChatPostRef = useRef();
    const handleOnclickInputChat = () => {
        txtChatPostRef?.current?.focus();
    };

    // Keep the scroll position in place when toggling the translation view (all logic lives in the hook).
    const { onChatScroll } = useKeepChatScrollOnViewChange({
        panelId,
        chatThreadId,
        chatPostOnDemand,
        focusedMsgId,
        triggerFocusMsg
    });

    const jumpToBottom = () => {
        let idDivContentList = `divChatContentList-${panelId}-${chatThreadId}`;
        const element = document.getElementById(idDivContentList);
        element.scrollTop = element.scrollHeight;
        setIsDisplayJump(false);
    };

    const handleReloadTicketDeleted = async () => {
        setDisableButtonCallBack(true);
        await updateUserWorkspacePanel(ticketIdSelected, false);
        window.location.reload();
    };

    // add scroll to input when maxHeight inputWrap = 440px
    const chatInputWrapElement = document.querySelector('.formChat-wrap');
    const textareaElement = document.querySelector('.chat-input-knowledge-wrap textarea');

    if (chatInputWrapElement && textareaElement) {
        const style = window.getComputedStyle(textareaElement);

        const borderTop = parseInt(style.borderTopWidth, 10);
        const borderBottom = parseInt(style.borderBottomWidth, 10);
        const paddingTop = parseInt(style.paddingTop, 10);
        const paddingBottom = parseInt(style.paddingBottom, 10);
        const textareaHeight = Number(textareaElement.clientHeight);

        const maxHeightChatInputWrap =
            borderTop + borderBottom + paddingTop + paddingBottom + textareaHeight;
        if (Number(chatInputWrapElement.clientHeight) >= maxHeightChatInputWrap) {
            textareaElement.style.overflowY = 'hidden';
        }
        if (Number(chatInputWrapElement.clientHeight) < maxHeightChatInputWrap) {
            textareaElement.style.overflowY = 'auto';
        }
    }

    const getUserSendMsgNameInHistory = () => {
        if (!Utils.isEmptyObject(msgEditSelected?.userDetailPostMsg)) {
            let userName = Utils.getFullNameOfUser(
                Constant.LANGUAGE_TYPE.JP,
                msgEditSelected?.userDetailPostMsg
            );
            if (userName) {
                return userName;
            }
        }

        return msgEditSelected?.userDetailPostMsg?.mail;
    };

    useEffect(() => {
        if (focusedMsgId && !!triggerFocusMsg) {
            const el = document.getElementById(focusedMsgId);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [focusedMsgId, triggerFocusMsg]);

    useEffect(() => {
        const handleClickOutside = () => {
            setFocusedMsgId(null);
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    /**
     * Render view
     */
    return (
        <div className="groupChat">
            <TicketKnowledgeHead
                {...props}
                API={API}
                isShowHeadlineButtonGroup={props.isShowHeadlineButtonGroup}
                isShowAllChatPost={isShowAllChatPost}
                setIsShowAllChatPost={setIsShowAllChatPost}
                disableAutoScroll={disableAutoScroll}
                // handleClickViewTicketDetail={handleClickViewTicketDetail}
                ticketInfo={ticketInfo}
                selectThread={selectThread}
                chatPostAllList={chatPostAllList}
                chatThreadId={chatThreadId}
                userDetail={userDetail}
                setIsLoading={setIsLoading}
                setTicketInfo={setTicketInfo}
                panelId={panelId}
                ticketId={ticketIdSelected}
                panelType={props.panelType}
            />
            <div className="chatContent">
                <div
                    className="scrollBar-main"
                    id={`divChatContentList-${panelId}-${chatThreadId}`}
                    onScroll={e => {
                        onChatScroll();
                        handleScrollListMessage(e, args, chatThreadId);
                    }}
                >
                    {chatPostByChatThreadIdList && renderChatList()}
                </div>
                <div
                    className={isDisplayJump ? 'jumpBottom' : 'jumpBottom jumpBottom--dnone'}
                    onClick={jumpToBottom}
                >
                    <div className="jumpBottom-wrap">
                        <div className="jumpBottom-box">
                            <svg width="16px" height="16px" viewBox="0 0 24 24" className="">
                                <path fill="none" d="M0 0h24v24H0V0z"></path>
                                <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path>
                            </svg>
                            {tr('Jump to Bottom')}
                        </div>
                    </div>
                </div>
            </div>
            <div className="formChat-wrap">
                {isEnableChat && (
                    <div className="formChat">
                        <div className="groupForm-chat">
                            {!!uploadFiles.length && (
                                <div className="container-files-input">
                                    {uploadFiles.map((file, index) => {
                                        if (Utils.isImageFile(file.fileData.name)) {
                                            return (
                                                <div className="container-image-item" key={file.id}>
                                                    <img
                                                        src={file.localUrl}
                                                        alt={`upload-${index}`}
                                                        onClick={() =>
                                                            setOpenPreviewImage(file.localUrl)
                                                        }
                                                        style={{
                                                            borderRadius: 6,
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                    {!file.s3Path ? (
                                                        <CircularProgress
                                                            size={14}
                                                            style={{
                                                                position: 'absolute',
                                                                inset: 0,
                                                                margin: 'auto'
                                                            }}
                                                        />
                                                    ) : (
                                                        <div
                                                            className="file-remove-btn"
                                                            onClick={() => deleteFile(file)}
                                                        >
                                                            <CloseIcon
                                                                style={{ width: 14, height: 14 }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <Tooltip
                                                    key={file.id}
                                                    title={file.fileData.name}
                                                    placement="top"
                                                    arrow
                                                >
                                                    <div className="container-file-item">
                                                        <FileIcon
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                color: '#2d72d2'
                                                            }}
                                                        />
                                                        <div className="container-file-name-item">
                                                            <span>{file.fileData.name}</span>
                                                            <span>
                                                                {file.fileData.name
                                                                    .split('.')
                                                                    .pop()
                                                                    .toLowerCase()}
                                                            </span>
                                                        </div>
                                                        {!file.s3Path ? (
                                                            <CircularProgress
                                                                size={14}
                                                                style={{
                                                                    position: 'absolute',
                                                                    inset: 0,
                                                                    margin: 'auto'
                                                                }}
                                                            />
                                                        ) : (
                                                            <div
                                                                className="file-remove-btn"
                                                                onClick={() => deleteFile(file)}
                                                            >
                                                                <CloseIcon
                                                                    style={{
                                                                        width: 14,
                                                                        height: 14
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </Tooltip>
                                            );
                                        }
                                    })}
                                </div>
                            )}
                            <div className="group-fild">
                                <div
                                    onPaste={handlePaste}
                                    className={`single-line chat-input-knowledge-wrap ${
                                        !Utils.isEmptyString(ticketInfo.deletedAt) ||
                                        ticketInfo.public === Constant.TICKET_PUBLIC.DRAFT ||
                                        loadingInput
                                            ? 'disable-textarea'
                                            : ''
                                    }`}
                                    data-cy="chat-form-input-field"
                                    {...getRootProps()}
                                >
                                    <MentionsInput
                                        {...getInputProps()}
                                        forceSuggestionsAboveCursor={true}
                                        // inputRef={txtChatPostRef}
                                        onClick={handleOnclickInputChat}
                                        value={newMessage}
                                        rows={1}
                                        onChange={handleAddNewMessage}
                                        placeholder={tr('あなたのメッセージ...')}
                                        className="mentionWrapper"
                                        classNames={classNames}
                                        style={defaultMentionStyle}
                                        disabled={
                                            !Utils.isEmptyString(ticketInfo.deletedAt) ||
                                            ticketInfo.public === Constant.TICKET_PUBLIC.DRAFT ||
                                            loadingInput
                                        }
                                        onKeyDown={e => handleOnKeyPress(e)}
                                    >
                                        <Mention
                                            className={classNames.mentions__mention}
                                            style={{
                                                fontSize: '15px',
                                                lineHeight: 1.8
                                            }} /* hot fix mention input */
                                            trigger={/(?:^|\s)(@([^\s]*))$/}
                                            // trigger="@"
                                            displayTransform={displayTransform}
                                            markup="@[__display__](__id__)"
                                            data={listRenderMention}
                                            onAdd={onAddMention}
                                            renderSuggestion={handleSuggestion}
                                            appendSpaceOnAdd={true}
                                        />
                                    </MentionsInput>
                                </div>

                                <div className="group-fildBtn">
                                    <div className="icon-tools">
                                        <IconButton
                                            className="itemTools"
                                            style={{ display: 'none' }}
                                        >
                                            <img src="/assets/image/icon-color.svg" alt="" />
                                        </IconButton>
                                    </div>
                                    <div className="icon-tools" style={{ display: 'none' }}>
                                        <IconButton className="itemTools">
                                            <img src="/assets/image/icon-smile.svg" alt="" />
                                        </IconButton>
                                    </div>
                                    <div className="icon-tools">
                                        <input
                                            multiple
                                            accept="*"
                                            className="upload"
                                            id={`icon-button-photo-${panelId}`}
                                            type="file"
                                            onChange={handlePostImageFileOnChange}
                                            disabled={
                                                !Utils.isEmptyString(ticketInfo.deletedAt) ||
                                                ticketInfo.public ===
                                                    Constant.TICKET_PUBLIC.DRAFT ||
                                                loadingInput
                                            }
                                        />
                                        <label htmlFor={`icon-button-photo-${panelId}`}>
                                            <IconButton
                                                className="itemTools"
                                                aria-label="upload picture"
                                                component="span"
                                                disabled={
                                                    !Utils.isEmptyString(ticketInfo.deletedAt) ||
                                                    ticketInfo.public ===
                                                        Constant.TICKET_PUBLIC.DRAFT
                                                }
                                            >
                                                <img
                                                    src="/assets/image/icon-fileUpload.svg"
                                                    alt=""
                                                />
                                            </IconButton>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                className={`groupBtn-send ${
                                    isDisabledBtnSend ? 'groupBtn-send-disable' : ''
                                }`}
                            >
                                <IconButton
                                    className="btnSend"
                                    onClick={e => handleEventOnSubmitMessage()}
                                    disabled={isDisabledBtnSend}
                                >
                                    {loadingInput ? (
                                        <CircularProgress size={28} />
                                    ) : (
                                        <img src="/assets/image/icon-send.svg" alt="" />
                                    )}
                                </IconButton>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <ErrorModal
                open={isModalUploadFileError}
                message={trI18n('USER07MSG004')}
                handleCloseDialog={() => setIsModalUploadFileError(false)}
            />
            {/* show history dialog */}
            <Dialog
                open={isOpenHistoryDialog}
                onClose={e => {
                    setIsOpenHistoryDialog(false);
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="wrapDialog"
            >
                <DialogTitle className="titleHeader">
                    <h2 className="title">{tr('編集履歴')}</h2>
                    {msgEditSelected?.creatorId && (
                        <h5 className="userNameHistoryTitle">{getUserSendMsgNameInHistory()}</h5>
                    )}
                    <IconButton
                        className="close"
                        onClick={e => {
                            setIsOpenHistoryDialog(false);
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {isLoadingHistoryList ? (
                        <LoadingIndicator isLoading={isLoadingHistoryList} />
                    ) : (
                        <div className="contentChart-dialog text-align-left-important">
                            <ul>{historyList}</ul>
                        </div>
                    )}
                </DialogContent>
            </Dialog>
            <DataChangePleaseReloadModal
                {...args}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <DeleteMessageDialog argsAll={args} />
            <ConfirmDialog
                isOpen={isShowConfirmMaxFileSize}
                msgConfirm={trI18n('COMMSG021').replace(
                    '{{fileSize}}',
                    Constant.CHAT_THREAD_MAX_MB_FILE_UPLOAD
                )}
                okCallBack={() => setIsShowConfirmMaxFileSize(false)}
                textSubmit={trI18n('COMBTN004')}
            />
            <ReactionErrorDialog
                isOpen={isOpenReactionErrorDialog}
                setIsOpen={setIsOpenReactionErrorDialog}
                reactionErrorMsg={reactionErrorMsg}
                setReactionErrorMsg={setReactionErrorMsg}
            />
            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={trI18n('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={tr('はい')}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={trI18n('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={trI18n('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />

            <ConfirmDialog
                isOpen={isOpenModalTicketDeleted}
                msgConfirm={trI18n('MSG-CM-DELETED-TICKET')}
                okCallBack={handleReloadTicketDeleted}
                disableButtonCallBack={disableButtonCallBack}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={
                    <div>
                        <span>{trI18n('MSG-CM-EXPIRED-SESSION-1')}</span>
                        <br />
                        <span>{trI18n('MSG-CM-EXPIRED-SESSION-2')}</span>
                    </div>
                }
                textSubmit={trI18n('COMBTN004')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
}
